export default {
  methods: {
    $capitalize: function (value) {
        if (!value) return '';
        value = value.toString().trim().split(' ');
        return value.map(v => v.charAt(0).toUpperCase() + v.slice(1)).join(' ');
    },
  }
}
